import styled from "styled-components";

export const AddCompanyWrapperEl = styled.div`
	position: absolute;
	top: 5%;
	width: 500px;
	left: calc(50% - 250px);
	min-height: 200px;
	max-height: 90%;
	overflow: auto;
	background: var(--bg-d2);
	border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16));
	border-radius: 12px;
	box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
	transition: height 0.15s, -moz-transform ease-in-out 0.15s;

	& .modal-header-wrapper {
		background: transparent;
		border-bottom: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16));
		padding: 25px 0;
	}

	& .cancel-btn {
		height: 30px;
		width: 30px;
		position: absolute;
		top: 20px;
		right: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: var(--bg-d0-dash);
		border-radius: 50%;
		transition: background 0.1s ease, color 0.1s ease;
	}

	& .cancel-btn:hover {
		cursor: pointer;
		background: var(--bg-dg);
	}

	& .cancel-btn:hover > span {
		color: var(--txt-l);
	}

	& .cancel-btn span {
		font-size: 14px;
		line-height: 1;
		font-weight: 700;
		color: var(--txt-lg);
	}

	& .title-wrapper {
		display: block;
	}

	& .title-wrapper h1 {
		color: var(--txt-l);
		font-size: 16px;
		padding-left: 25px;
	}

	& .title-wrapper p {
		color: var(--txt-lg);
		font-size: 13px;
		padding-left: 25px;
		margin-top: 5px;
	}

	& .url-wrapper {
		display: block;
		padding: 15px 25px;
		position: relative;
	}

	& .url-wrapper label {
		display: block;
		font-size: 13px;
		margin-bottom: 2px;
		margin-left: 0;
	}

	& .url-wrapper label {
		color: var(--txt-l);
	}

	& .url-wrapper p {
		display: block;
		font-size: 13px;
		margin-bottom: 10px;
		color: var(--txt-lg);
		margin-left: 0;
	}

	& .url-wrapper input {
		display: block;
		font-size: 13px;
		margin-bottom: 5px;
		width: 100%;
		padding: 15px;
		border-radius: 6px;
		border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16));
		background: var(--bg-d0-dash);
		color: var(--txt-l);
	}

	& .url-wrapper input::selection {
		background: rgba(31, 133, 222, 0.4);
	}

	& .url-wrapper input::placeholder {
		color: var(--txt-lg);
	}

	& .url-wrapper input:focus {
		border: 1px solid var(--blue);
	}

	& .url-wrapper input.valid {
		border: 1px solid var(--green) !important;
		background: var(--highlight-green-d) !important;
	}

	& .manual-entry-btn {
		//background: var(--blue);
		padding: 0 25px;
		font-size: 13px;
		color: var(--blue);
		border-radius: 3px;
		text-align: center;
		margin: 15px auto 5px auto;
		transition: background 0.05s, -moz-transform ease-in-out 0.05s;
	}

	& .manual-entry-btn:hover {
		cursor: pointer;
		text-decoration: underline;
	}

	& .login-error-wrapper {
		width: 100%;
		padding: 0 25px 0 25px;
		margin-top: 15px;
	}

	& .company-data-wrapper {
		display: block;
		padding: 5px 25px 35px 25px;
		position: relative;
		min-height: 100px;
		border-top: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16));
	}

	& .company-data-section {
		padding-top: 10px;
	}

	& .company-data-section label {
		font-size: 12px;
		margin-left: 1px;
		display: inline-block;
		vertical-align: top;
		margin-top: 5px;
		pointer-events: none;
		color: var(--txt-l);
	}

	& .company-data-section p {
		font-size: 12px;
		margin-top: 6px;
		margin-right: 2px;
		float: right;
		color: var(--txt-lg);
		pointer-events: none;
	}

	& .company-data-section .help-text {
		display: block;
		clear: both;
		font-size: 12px;
		color: var(--txt-lg);
		margin-top: 2px;
		pointer-events: none;
	}

	& .company-data-section.red p {
		color: var(--red);
	}

	& .company-data-section.green p {
		color: var(--green);
	}

	& .company-data-section.red label {
		color: var(--red);
	}

	& .company-data-section.green label {
		color: var(--green);
	}

	& .company-data-section label a {
		pointer-events: auto;
		color: var(--violet);
	}

	& .company-data-section label a:hover {
		cursor: pointer;
		text-decoration: underline;
	}

	& .company-data-section .favicon {
		margin-top: 4px;
		margin-left: 5px;
		height: 16px;
		width: 16px;
		vertical-align: top;
	}

	& .company-data-section textarea {
		font-size: 13px;
		margin-top: 6px;
		display: block;
		width: 100%;
		border-radius: 6px;
		padding: 10px;
		border: 1px solid var(--border-subtle, rgba(140, 150, 170, 0.16));
		height: inherit;
		margin-bottom: 5px;
		resize: none;
		background: var(--bg-d0-dash);
		color: var(--txt-l);
		outline: none;
		transition: border-color 0.15s ease;
	}

	& .company-data-section textarea:focus {
		border: 1px solid var(--blue);
	}

	& .company-data-section textarea::selection {
		background: rgba(31, 133, 222, 0.4);
	}

	& .company-data-section.red textarea {
		border: 1px solid var(--red);
		background: var(--highlight-red-d);
	}

	& .company-data-section.green textarea {
		border: 1px solid var(--green);
		background: var(--highlight-green-d);
	}

	& .company-data-section textarea::placeholder {
		color: var(--txt-lg);
	}

	& .company-submit-btn {
		font-size: 1.25em;
	}

	& .company-redirect-btn {
		background: var(--violet);
		padding: 20px;
		font-size: 13px;
		font-weight: 700;
		color: white;
		border-radius: 3px;
		text-align: center;
		margin: -5px auto 10px auto;
		transition: background 0.05s, -moz-transform ease-in-out 0.05s;
	}

	& .company-redirect-btn:hover {
		cursor: pointer;
		background: var(--darkviolet);
	}

	/* Light theme overrides */
	html#light & {
		background: var(--bg-l1-2);
		border-color: var(--bg-l1-3);
		box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);

		.modal-header-wrapper {
			background: #fff;
			border-bottom-color: var(--bg-l1-3);
		}
		.cancel-btn {
			background: var(--bg-l2);
		}
		.cancel-btn span {
			color: var(--txt-dg);
		}
		.cancel-btn:hover {
			background: var(--bg-l3);
		}
		.title-wrapper h1 {
			color: var(--txt-d);
		}
		.title-wrapper p,
		.url-wrapper p,
		.company-data-section p {
			color: var(--txt-dg);
		}
		.url-wrapper label,
		.company-data-section label {
			color: var(--txt-d);
		}
		.url-wrapper input,
		.company-data-section textarea {
			background: #fff;
			color: #000;
			border-color: var(--bg-l3);
		}
		.company-data-wrapper {
			border-top-color: var(--bg-l1-3);
		}
		.company-data-section.red label,
		.company-data-section.red p {
			color: var(--darkred);
		}
		.company-data-section.green label,
		.company-data-section.green p {
			color: var(--lt-green);
		}
		.company-data-section label a {
			color: var(--darkviolet);
		}
	}

	@media screen and (max-height: 800px) {
		top: 0;
		max-height: 100%;
		height: 100%;
		border-radius: 0;
	}
`;
